module.exports = __webpack_public_path__ + "assets/img/241401.8ee01b84.png";